import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row } from "react-bootstrap";
import ApiAgent from "../../../../../../core/api/api.agent";

export const ViewAgentDetails = ({ showModalAgent, setShowModalAgent, selectedAgent }) => {
  const [agent, setAgent] = useState([]);
  const handleClose = () => {
    setShowModalAgent(false);
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedAgent != 0) {
          const response = await ApiAgent.getAllAgentById(selectedAgent);
          if (response.succeeded == true) {
            // مقدار اولیه
            setAgent(response.data);
          }
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, []);

  return (
    <div>
      <Modal centered size="lg" show={showModalAgent} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> مشاهده جزئیات نماینده </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small">نام شرکت </div>
              <div className="fw-bold">{agent.companyName ? agent.companyName : "----"}</div>
            </Col>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small"> شماره موبایل </div>
              <div className="fw-bold">{agent.phoneNumber ? agent.phoneNumber : "----"}</div>
            </Col>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small"> نام و نام خانودگی مدیرعامل </div>
              <div className="fw-bold">
                {agent.ceoFirstName ? agent.ceoFirstName : "----"} {agent.ceoLastName ? agent.ceoLastName : "----"}
              </div>
            </Col>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small">شناسه ملی شرکت </div>
              <div className="fw-bold">{agent.companyNationalId ? agent.companyNationalId : "----"}</div>
            </Col>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small"> مجوز شرکت </div>
              <div className="fw-bold">{agent.licenseTypeS ? agent.licenseTypeS : "----"}</div>
            </Col>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small"> شهر شرکت </div>
              <div className="fw-bold">{agent?.city?.name ? agent.city?.name : "----"}</div>
            </Col>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small"> شماره ملی مدیرعامل </div>
              <div className="fw-bold">{agent.ceoIdentityNumber ? agent.ceoIdentityNumber : "----"}</div>
            </Col>
            <Col xs="12" sm="6" md="4" xl="3" className="mb-5">
              <div className="opacity-60 mb-2 text-small"> وضعیت نماینده </div>
              <div className="fw-bold">{agent.agentApprovalStatusS ? agent.agentApprovalStatusS : "----"}</div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
